const sidebar = document.querySelector('#article-sidebar');

if (sidebar && !document.body.classList.contains('KenticoAdminPageBuilder')) {
  const sidebarContent = sidebar.querySelector('#article-sidebar-content');

  // Disable sticky sidebar if it's taller than the viewport
  if (sidebarContent) {
    const setStickySidebar = () => {
      sidebarContent.classList.toggle(
        'disable-sticky',
        sidebarContent.offsetHeight >= window.innerHeight
      );
    };

    setStickySidebar();

    window.addEventListener('resize', setStickySidebar);
  }

  const tableOfContents = sidebar.querySelector('.table-of-contents');

  if (tableOfContents) {
    // Highlight the current section in the table of contents
    const sections = document.querySelectorAll(
      '.article-section[data-table-of-contents="true"]'
    );

    if (window.IntersectionObserver && sections.length) {
      const sentinel = document.querySelector('.sidebar-sentinel');

      if (sentinel) {
        const sentinelObserver = new IntersectionObserver(([entry]) => {
          tableOfContents.classList.toggle(
            'show-active',
            !entry.isIntersecting
          );
        });

        sentinelObserver.observe(sentinel);
      }

      const intersectionData = {};

      let isScrollingToSection = false;
      let scrollTimer = null;
      let intersectionTimer = null;

      // Smooth scroll to section and don't change page URL
      tableOfContents.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', e => {
          if (!link.hash) return;

          const section = document.querySelector(link.hash);
          if (!section || !intersectionData[section.id]) return;

          e.preventDefault();

          const { listItem } = intersectionData[section.id];

          if (listItem) {
            isScrollingToSection = true;

            clearTimeout(scrollTimer);
            clearTimeout(intersectionTimer);

            tableOfContents
              .querySelectorAll('li.current')
              .forEach(el => el.classList.remove('current'));

            listItem.classList.add('current');
          }

          section.scrollIntoView({ behavior: 'smooth' });
        });
      });

      const enableIntersectionChecks = () => {
        if (!isScrollingToSection) return;

        clearTimeout(scrollTimer);
        isScrollingToSection = false;
        handleIntersection();
      };

      window.addEventListener('scroll', () => {
        if (!isScrollingToSection) return;

        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(enableIntersectionChecks, 100);
      });

      window.addEventListener('wheel', enableIntersectionChecks);
      window.addEventListener('touchmove', enableIntersectionChecks);

      const handleIntersection = () => {
        clearTimeout(intersectionTimer);

        if (isScrollingToSection) return;

        intersectionTimer = setTimeout(() => {
          if (isScrollingToSection) return;
          let currentSectionId = null;

          Object.keys(intersectionData).forEach(id => {
            const { ratio, index } = intersectionData[id];

            if (ratio <= 0) return;
            if (currentSectionId === null) {
              currentSectionId = id;
            } else {
              const currentSection = intersectionData[currentSectionId];

              if (
                ratio > currentSection.ratio ||
                (ratio === currentSection.ratio && index < currentSection.index)
              ) {
                currentSectionId = id;
              }
            }
          });

          tableOfContents
            .querySelectorAll('li.current')
            .forEach(el => el.classList.remove('current'));

          if (currentSectionId === null) return;

          const { listItem } = intersectionData[currentSectionId];
          if (!listItem) return;

          listItem?.classList.add('current');
        }, 5);
      };

      const sectionObserver = new IntersectionObserver(
        entries => {
          let entry = null;

          entries.forEach(item => {
            if (!entry || item.intersectionRatio > entry.intersectionRatio) {
              entry = item;
            }
          });

          if (!entry) return;

          const { target, intersectionRatio } = entry;

          if (intersectionData[entry.target.id]) {
            intersectionData[target.id].ratio = Math.round(
              intersectionRatio * 10
            );

            intersectionData[target.id].entry = entry;
          }

          handleIntersection();
        },
        {
          threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
        }
      );

      sections.forEach((section, index) => {
        if (!section.id) return;
        const link = tableOfContents.querySelector(`a[href="#${section.id}"]`);
        const listItem = link?.closest('li');
        if (!listItem) return;

        intersectionData[section.id] = { section, listItem, index, ratio: 0 };
        sectionObserver.observe(section);
      });
    }
  }
}
